{
  "it": {
    "ai": {
      "activation": {
        "activate": "Attiva",
        "activated": "L'assistente IA è attivo per {client}.",
        "agreement_required": "Spunti prima la casella di accettazione.",
        "deactivated": "L'assistente IA è disattivato per {client}.",
        "not_now": "Non ora",
        "prompt": {
          "agreement": "Per conto di {client}, accetto Google Cloud come sub-responsabile del trattamento per questa funzione.",
          "dpa_label": "Accordo sul trattamento dei dati aggiornato",
          "dpa_url": "https://ziggu.io/terms-and-conditions-13-10-2026",
          "intro": "Riassuma le conversazioni e riceva proposte di risposta. Prova gratuita fino al 31 dicembre 2026.",
          "processing": "Per usare l'assistente, il testo delle conversazioni viene elaborato tramite Google Cloud (Gemini) all'interno dell'UE. Google non utilizza questi dati per addestrare modelli.",
          "retention": "Conserviamo le conversazioni con l'assistente per {count} mese. | Conserviamo le conversazioni con l'assistente per {count} mesi.",
          "settings": "Può attivare o disattivare l'assistente in qualsiasi momento nelle impostazioni, in {features} > {conversations}.",
          "title": "Novità: assistente IA per il team di progetto"
        },
        "settings": {
          "description": "Riassume le conversazioni e propone risposte. Per attivarlo deve accettare Google Cloud come sub-responsabile del trattamento.",
          "impersonation": "Solo un proprietario del cliente può attivarlo o disattivarlo, non in una sessione «accedi come».",
          "owner_only": "Chieda a un proprietario di attivare l'assistente IA.",
          "owner_only_enabled": "Solo un proprietario può disattivare l'assistente IA.",
          "title": "Assistente IA",
          "toggle": "Assistente IA nelle conversazioni"
        },
        "snoozed": "Potrà attivare l'assistente IA in seguito nelle impostazioni, in {features} > {conversations}."
      },
      "assistant": {
        "all_projects": "Tutti i progetti",
        "cap": {
          "action": "Avvia una nuova conversazione",
          "message": "Ha raggiunto il limite di conversazioni."
        },
        "empty_state": {
          "subtitle": "Mi chieda qualsiasi cosa sui Suoi clienti",
          "title": "Come posso aiutarLa?"
        },
        "errors": {
          "budget_reached": "Il budget AI di questo mese è esaurito. Contatti Ziggu per aumentarlo.",
          "generic": "Qualcosa è andato storto. Riprovi."
        },
        "history": {
          "empty": "Nessuna conversazione precedente",
          "title": "Conversazioni precedenti"
        },
        "input": {
          "disclaimer": "I risultati potrebbero non essere accurati. Verifichi sempre le informazioni importanti.",
          "hint": "Invio per inviare · Maiusc+Invio per andare a capo",
          "placeholder": "Chieda dei Suoi clienti…"
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Come configuro le notifiche?",
          "help_project_settings": "Dove trovo le impostazioni del progetto?",
          "open_decisions": "Quali decisioni sono ancora aperte?",
          "unassigned_units": "Quali unità non hanno ancora un cliente?"
        },
        "support_cta": {
          "action": "Contatta il supporto",
          "prompt": "Non è la risposta che cercava?"
        }
      },
      "dashboard": {
        "agents": {
          "all": "Tutti i moduli",
          "assistant": "Assistente",
          "conversation_agent": "Agente conversazionale",
          "label": "Modulo"
        },
        "allowance": {
          "edit": "Modifica budget"
        },
        "allowance_boost": {
          "action": "Aumenta temporaneamente",
          "action_short": "Aumenta",
          "amount_label": "Importo aggiuntivo",
          "existing": "In questo periodo è già attivo un aumento di {amount}. Questo importo si somma.",
          "expires": "Si aggiunge al budget solo per questo periodo e scade il {date}.",
          "expires_next_reset": "Si aggiunge al budget solo per questo periodo e scade al prossimo azzeramento.",
          "save": "Aggiungi aumento",
          "saved": "Aumento di {amount} aggiunto"
        },
        "allowance_history": {
          "empty": "Ancora nessuna modifica",
          "empty_hint": "Questo cliente usa ancora il budget che gli è stato assegnato.",
          "entry": "{field}: {before} → {after}",
          "package_amount": "importo del pacchetto",
          "title": "Storico del budget",
          "unknown_author": "Sconosciuto"
        },
        "chat_detail": {
          "employee": "Dipendente",
          "empty": "Questa chat non ha messaggi",
          "feedback": {
            "down": "Risposta sbagliata",
            "up": "Risposta utile"
          },
          "text_hidden": "Non condiviso dal dipendente",
          "title": "Conversazione"
        },
        "chats": {
          "columns": {
            "cost": "Costo",
            "employee": "Dipendente",
            "intent": "Intento",
            "ticket": "Ticket",
            "turns": "Turni",
            "when": "Quando"
          },
          "empty": "Nessuna chat in questo periodo",
          "feedback_label": "Valutazione",
          "feedbacks": {
            "all": "Qualsiasi valutazione",
            "down": "Pollice in giù",
            "up": "Pollice in su"
          },
          "intent_label": "Intento",
          "open": "Apri chat",
          "title": "Chat",
          "via": "tramite {name}"
        },
        "client": {
          "allowance_boost": "{amount} aggiuntivi fino al {date}",
          "allowance_boost_next_reset": "{amount} aggiuntivi fino al prossimo azzeramento",
          "allowance_free": "{amount} gratuito",
          "allowance_paid": "{amount} a pagamento",
          "employees_active": "{count} dipendente attivo | {count} dipendenti attivi",
          "over_since": "Superato dal {date}",
          "title": "{name} · AI",
          "used": "{used} di {allowance} utilizzati"
        },
        "clients": {
          "allowance_split": "Gratuito {free} · A pagamento {paid}",
          "allowance_split_boost": "Gratuito {free} · A pagamento {paid} · Aggiuntivo {boost}",
          "columns": {
            "actions": "Azioni",
            "allowance": "Budget",
            "chats": "Chat nel periodo",
            "client": "Cliente",
            "spend": "Spesa nel periodo",
            "status": "Stato",
            "used": "Utilizzato questo mese"
          },
          "empty": "Nessun cliente ha usato l'AI in questo periodo",
          "export": "Esporta",
          "title": "Clienti"
        },
        "empty_hint": "Nessun risultato per questo modulo e periodo.",
        "intent_mix": {
          "empty": "Nessuna chat in questo periodo",
          "row": "{chats} chat · {amount} | {chats} chat · {amount}",
          "title": "Distribuzione per intento"
        },
        "intents": {
          "all": "Tutti gli intenti",
          "draft": "Scrivi una bozza di risposta",
          "none": "Senza intento",
          "question": "Chiedi",
          "summary": "Riassunto"
        },
        "kpi": {
          "clients_active": "Clienti attivi",
          "employees_active": "Dipendenti attivi",
          "spend_month": "Spesa questo mese",
          "spend_month_detail": "Mese solare in corso",
          "spend_range": "Spesa nel periodo",
          "spend_range_detail": "{count} chat in questo periodo | {count} chat in questo periodo",
          "spend_today": "Spesa di oggi",
          "tickets_assisted": "Ticket assistiti"
        },
        "load_failed": {
          "description": "Ricarichi la pagina o scelga un altro periodo.",
          "title": "Impossibile caricare l'utilizzo dell'IA"
        },
        "range": {
          "label": "Periodo"
        },
        "spend": {
          "empty": "Nessuna spesa in questo periodo",
          "monthly_empty": "Nessuna spesa negli ultimi {months} mesi",
          "monthly_hint": "Ultimi {months} mesi · indipendente dal periodo selezionato",
          "monthly_title": "Costo per mese",
          "monthly_total": "{amount} negli ultimi {months} mesi · indipendente dal periodo selezionato",
          "title": "Spesa al giorno",
          "total": "{amount} nel periodo",
          "view": {
            "label": "Mostra spesa",
            "per_day": "Al giorno",
            "running_total": "Cumulativo"
          }
        },
        "status": {
          "over": "Budget superato",
          "over_days": "Superato · 1 giorno | Superato · {count} giorni"
        },
        "title": "Utilizzo AI"
      },
      "settings": {
        "budget": {
          "amount_error": "Inserisca un importo come 2 o 2.50",
          "boost_label": "Aumento temporaneo",
          "boost_label_until": "Aumento temporaneo fino al {date}",
          "description": "Limite di spesa mensile per l'utilizzo dell'AI (fase di test). Ricalcolato in base all'utilizzo dei token in tutte le conversazioni di questo mese.",
          "free_label": "Budget gratuito",
          "override_help": "Lasci vuoto per utilizzare l'importo del pacchetto ({amount}).",
          "override_label": "Budget gratuito personalizzato",
          "paid_label": "Budget a pagamento",
          "save": "Salva",
          "title": "Budget mensile",
          "total_label": "Budget totale",
          "usage_label": "Utilizzato questo mese",
          "usage_of": "Utilizzato questo mese, su {amount}",
          "use_package_amount": "Usa l'importo del pacchetto"
        },
        "description": "Configurazione delle funzionalità AI nella Sua organizzazione.",
        "title": "Impostazioni AI",
        "usage": {
          "description": "Quanto del credito AI di questo mese è stato utilizzato. Al 100% le funzioni AI si fermano fino al rinnovo del credito il mese prossimo.",
          "title": "Utilizzo dell'AI"
        }
      },
      "ticket_assistant": {
        "actions": {
          "adjust": "Modifica",
          "ask": "Chiedi",
          "draft": "Scrivi una bozza di risposta",
          "draft_empty": "Ancora nessun messaggio a cui rispondere",
          "follow_up": "Approfondisci",
          "follow_up_stop": "Interrompi l'approfondimento",
          "new": "Nuova domanda",
          "summary": "Riassumi la conversazione",
          "summary_empty": "Ancora nessun messaggio da riassumere",
          "use_as_reply": "Usa come risposta"
        },
        "adjusting_draft": "Modifica di questa bozza",
        "beta": "Beta",
        "budget": {
          "description": "Il budget AI di questo mese è esaurito. Le risposte precedenti restano disponibili.",
          "request": "Abbiamo esaurito il budget AI di questo mese e vorremmo aumentarlo.",
          "request_low": "Abbiamo quasi esaurito il budget AI di questo mese e vorremmo aumentarlo.",
          "title": "Budget AI raggiunto",
          "warn": "{percent}% del budget AI di questo mese utilizzato."
        },
        "cap": "Questa chat è diventata lunga. Meglio fare una nuova domanda.",
        "collapse": "Nascondi assistente",
        "conversation": "Conversazione",
        "digest": {
          "decisions_open": "nessuna decisione aperta | 1 decisione aperta | {count} decisioni aperte",
          "installments_unpaid": "nessuna rata non pagata | 1 rata non pagata | {count} rate non pagate",
          "issues_open": "nessuna segnalazione post-vendita aperta | 1 segnalazione post-vendita aperta | {count} segnalazioni post-vendita aperte",
          "nothing_open": "Niente in sospeso per questa unità",
          "overdue": "{count} in ritardo",
          "title": "In sintesi"
        },
        "earlier_answers": "Risposte precedenti",
        "empty": "Chieda qualcosa su questa conversazione o inizi con una di queste.",
        "expand": "Mostra assistente",
        "feedback": {
          "bad": "Risposta sbagliata",
          "consent": "Ziggu vedrà questa conversazione. Può contenere nomi e dati dei clienti.",
          "consent_shared": "Questa conversazione è già condivisa con Ziggu.",
          "good": "Risposta utile",
          "note": "Che cosa avrebbe dovuto dire? (facoltativo)",
          "send": "Invia",
          "share": "Condividi con Ziggu",
          "stop_sharing": "Interrompi la condivisione",
          "thanks": "Grazie per il Suo feedback.",
          "thanks_shared": "Grazie. Condivisa con Ziggu.",
          "undo": "Annulla"
        },
        "following_up": "Approfondimento di questa risposta",
        "footer": "Il supporto Ziggu lo legge solo se Lei lo condivide o concede l'accesso a Ziggu. Le risposte sono generate dall'AI e possono contenere errori.",
        "footer_shared": "Ha condiviso questa conversazione con Ziggu. Le risposte sono generate dall'AI e possono contenere errori.",
        "input": {
          "adjust_draft": "Modifichi questa bozza, ad es. più breve o più formale",
          "follow_up": "Faccia una domanda di approfondimento",
          "label": "La Sua domanda",
          "placeholder": "Chieda di questa conversazione"
        },
        "links": {
          "aftercare": "Post-vendita",
          "decisions": "Decisioni",
          "financials": "Finanze"
        },
        "placeholders": {
          "confirm": {
            "accept": "Invia comunque",
            "header": "Inviare con dati da completare?",
            "message": "L’assistente ha lasciato 1 dato da completare in questa risposta. | L’assistente ha lasciato {count} dati da completare in questa risposta."
          },
          "remaining": "1 dato da completare | {count} dati da completare"
        },
        "replace_reply": {
          "confirm": {
            "accept": "Sostituisci",
            "header": "Sostituire il testo che ha scritto?",
            "message": "La bozza sostituisce il testo nella casella di risposta."
          }
        },
        "suggestions": {
          "history": "Qual è la storia con questo cliente?",
          "issues_open": "Quante segnalazioni post-vendita sono ancora aperte?",
          "undecided": "Cosa non ha ancora deciso questo cliente?"
        },
        "thinking": "L'assistente sta lavorando...",
        "title": "Assistente"
      }
    }
  }
}
